import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ConsoleIcon = createIcon(
  'Console',
  <path d="M9.63157895,12.02 L14.3684211,12.02 L14.3684211,21 L9.63157895,21 L9.63157895,12.02 Z M16.2631579,21 L19.1052632,21 C20.1473684,21 21,20.1 21,19 L21,12 L16.2631579,12 L16.2631579,21 Z M19.1052632,3 L4.89473684,3 C3.85263158,3 3,3.9 3,5 L3,10 L21,10 L21,5 C21,3.9 20.1473684,3 19.1052632,3 Z M3,19 C3,20.1 3.85263158,21 4.89473684,21 L7.73684211,21 L7.73684211,12 L3,12 L3,19 Z" />
);

export default ConsoleIcon;
